import { render } from "./dateGames.vue?vue&type=template&id=3aad00ec&scoped=true"
import script from "./dateGames.vue?vue&type=script&lang=js"
export * from "./dateGames.vue?vue&type=script&lang=js"

import "@/styles/pt.css?vue&type=style&index=0&lang=css"
import "./dateGames.vue?vue&type=style&index=1&id=3aad00ec&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aad00ec"]])

export default __exports__